/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParsedDrawTime } from './ParsedDrawTime';
import {
    ParsedDrawTimeFromJSON,
    ParsedDrawTimeFromJSONTyped,
    ParsedDrawTimeToJSON,
} from './ParsedDrawTime';
import type { DrawWinnings } from './DrawWinnings';
import {
    DrawWinningsFromJSON,
    DrawWinningsFromJSONTyped,
    DrawWinningsToJSON,
} from './DrawWinnings';
import type { ParsedDrawBoard } from './ParsedDrawBoard';
import {
    ParsedDrawBoardFromJSON,
    ParsedDrawBoardFromJSONTyped,
    ParsedDrawBoardToJSON,
} from './ParsedDrawBoard';
import type { ParsedTicketType } from './ParsedTicketType';
import {
    ParsedTicketTypeFromJSON,
    ParsedTicketTypeFromJSONTyped,
    ParsedTicketTypeToJSON,
} from './ParsedTicketType';

/**
 * 
 * @export
 * @interface ParsedTicketGame
 */
export interface ParsedTicketGame {
    /**
     * 
     * @type {Array<ParsedDrawBoard>}
     * @memberof ParsedTicketGame
     */
    boards: Array<ParsedDrawBoard>;
    /**
     * Per-draw winnings (drawNumber -> winnings), produced by the wallet parser from the CGS payload.
     * Combines cash and free-play winnings for the draw — both are "what this draw won", keyed identically.
     * Contains entries only for resolved draws that won something (cash and/or free plays); consumers default
     * missing entries to 0 (resolved loser) or null (pending) based on whether the GDS draw result exists.
     * Absent/null when the result type's per-draw winnings are not resolvable (e.g. rapid).
     * @type {{ [key: string]: DrawWinnings; }}
     * @memberof ParsedTicketGame
     */
    winningsByDrawNumber?: { [key: string]: DrawWinnings; } | null;
    /**
     * Actual per-draw times, when the parser knows each draw's real time rather than only the window bounds. Used to
     * pair a draw to its GDS result by time for feeds whose results carry no `drawingNumber` (e.g. Wyoming): consumers
     * match each draw against the result at this exact time instead of linearly interpolating between
     * firstDrawTime/lastDrawTime, which is wrong for unevenly-spaced multi-draw tickets. Absent when only the window
     * bounds are known (interpolation fallback applies). An array (not a number-keyed map) because tsoa cannot model a
     * `Record<number, Date>`. Server-internal in practice — the wallet detail response also exposes the resolved
     * per-draw `drawOutcomes`, which is what clients render; this raw field just feeds that resolution.
     * @type {Array<ParsedDrawTime>}
     * @memberof ParsedTicketGame
     */
    drawTimes?: Array<ParsedDrawTime> | null;
    /**
     * 
     * @type {Date}
     * @memberof ParsedTicketGame
     */
    lastDrawTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ParsedTicketGame
     */
    firstDrawTime: Date;
    /**
     * 
     * @type {number}
     * @memberof ParsedTicketGame
     */
    lastDrawNumber: number;
    /**
     * Inclusive draw range this game participates in.
     * @type {number}
     * @memberof ParsedTicketGame
     */
    firstDrawNumber: number;
    /**
     * Game-level add-ons purchased on this ticket entry, resolved to customer-facing display names
     * (e.g. "KENO 603 PLUS" for NH KENO multiplier purchases). Distinct from `multipliers`, which
     * carries the realized post-draw multiplier values. Distinct from per-panel keno
     * `addonSelection`, which models keno-specific per-board / per-panel add-ons (extra draws,
     * mini-games like Michigan's jack).
     * 
     * Populated for RAPID tickets only today. The wallet plugin fetches the GDS keno config and maps
     * the raw CGS identifier to `supportedAddOns.multiplierAddon.name`.
     * @type {Array<string>}
     * @memberof ParsedTicketGame
     */
    addons?: Array<string> | null;
    /**
     * Multipliers applied to this game (e.g. Power Play, Megaplier). Empty array if none.
     * @type {Array<number>}
     * @memberof ParsedTicketGame
     */
    multipliers: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ParsedTicketGame
     */
    costInCents: number;
    /**
     * 
     * @type {string}
     * @memberof ParsedTicketGame
     */
    logoUrl?: string | null;
    /**
     * Resolved at detail-read time from GDS.
     * @type {string}
     * @memberof ParsedTicketGame
     */
    gameName: string;
    /**
     * Resolved GDS game UUID.
     * @type {string}
     * @memberof ParsedTicketGame
     */
    gameId: string;
    /**
     * 
     * @type {ParsedTicketType}
     * @memberof ParsedTicketGame
     */
    ticketType: ParsedTicketType;
}



/**
 * Check if a given object implements the ParsedTicketGame interface.
 */
export function instanceOfParsedTicketGame(value: object): value is ParsedTicketGame {
    if (!('boards' in value) || value['boards'] === undefined) return false;
    if (!('lastDrawTime' in value) || value['lastDrawTime'] === undefined) return false;
    if (!('firstDrawTime' in value) || value['firstDrawTime'] === undefined) return false;
    if (!('lastDrawNumber' in value) || value['lastDrawNumber'] === undefined) return false;
    if (!('firstDrawNumber' in value) || value['firstDrawNumber'] === undefined) return false;
    if (!('multipliers' in value) || value['multipliers'] === undefined) return false;
    if (!('costInCents' in value) || value['costInCents'] === undefined) return false;
    if (!('gameName' in value) || value['gameName'] === undefined) return false;
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('ticketType' in value) || value['ticketType'] === undefined) return false;
    return true;
}

export function ParsedTicketGameFromJSON(json: any): ParsedTicketGame {
    return ParsedTicketGameFromJSONTyped(json, false);
}

export function ParsedTicketGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedTicketGame {
    if (json == null) {
        return json;
    }
    return {
        
        'boards': ((json['boards'] as Array<any>).map(ParsedDrawBoardFromJSON)),
        'winningsByDrawNumber': json['winningsByDrawNumber'] == null ? undefined : (mapValues(json['winningsByDrawNumber'], DrawWinningsFromJSON)),
        'drawTimes': json['drawTimes'] == null ? undefined : ((json['drawTimes'] as Array<any>).map(ParsedDrawTimeFromJSON)),
        'lastDrawTime': (new Date(json['lastDrawTime'])),
        'firstDrawTime': (new Date(json['firstDrawTime'])),
        'lastDrawNumber': json['lastDrawNumber'],
        'firstDrawNumber': json['firstDrawNumber'],
        'addons': json['addons'] == null ? undefined : json['addons'],
        'multipliers': json['multipliers'],
        'costInCents': json['costInCents'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'gameName': json['gameName'],
        'gameId': json['gameId'],
        'ticketType': ParsedTicketTypeFromJSON(json['ticketType']),
    };
}

export function ParsedTicketGameToJSON(value?: ParsedTicketGame | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'boards': ((value['boards'] as Array<any>).map(ParsedDrawBoardToJSON)),
        'winningsByDrawNumber': value['winningsByDrawNumber'] == null ? undefined : (mapValues(value['winningsByDrawNumber'], DrawWinningsToJSON)),
        'drawTimes': value['drawTimes'] == null ? undefined : ((value['drawTimes'] as Array<any>).map(ParsedDrawTimeToJSON)),
        'lastDrawTime': ((value['lastDrawTime']).toISOString()),
        'firstDrawTime': ((value['firstDrawTime']).toISOString()),
        'lastDrawNumber': value['lastDrawNumber'],
        'firstDrawNumber': value['firstDrawNumber'],
        'addons': value['addons'],
        'multipliers': value['multipliers'],
        'costInCents': value['costInCents'],
        'logoUrl': value['logoUrl'],
        'gameName': value['gameName'],
        'gameId': value['gameId'],
        'ticketType': ParsedTicketTypeToJSON(value['ticketType']),
    };
}

